import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgRulesVegetarianYes({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#E3E8E8" cx={12} cy={12} r={12} />
        <path
          d="M12 8.1c2.34 0 4.3 1.5 4.3 3.49 0 2.74-2.07 7.95-4.3 7.95-2.22 0-4.3-5.2-4.3-7.95 0-1.98 1.96-3.5 4.3-3.5zm0 1.5c-1.14 0-2.1.48-2.53 1.15h1.37a.75.75 0 010 1.5H9.25c.1.73.34 1.63.66 2.5h1.54a.75.75 0 110 1.5h-.92c.5 1.03 1.05 1.79 1.47 1.79.67 0 1.66-1.91 2.27-3.79h-1.32a.75.75 0 010-1.5h1.5c.07 0 .15.01.21.03.1-.45.15-.86.15-1.2 0-1.05-1.22-1.99-2.8-1.99zm2.98-5.1h.08a.5.5 0 01.4.59l-.05.24c-.22 1.01-.65 1.71-1.28 2.1-.79.48-1.5.6-2.14.35a1.34 1.34 0 01-.03-.08l-.03.08c-.64.25-1.35.13-2.14-.35-.63-.39-1.06-1.09-1.28-2.1l-.05-.24A.5.5 0 019 4.5a3.6 3.6 0 012.13 1.1c.42.41.7.8.82 1.17.13-.37.4-.76.82-1.17a3.6 3.6 0 012.13-1.1h.15z"
          fill="#666"
        />
      </g>
    </svg>
  );
}

SvgRulesVegetarianYes.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgRulesVegetarianYes.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgRulesVegetarianYes svgRef={ref} {...props} />
));
export default ForwardRef;
